<div matDialogTitle>{{ data.title }}</div>
<mat-dialog-content>
  <div class="form">

    <mat-form-field>
      <mat-label>Tidpunkt</mat-label>
      <input matInput readonly
             value="{{ data.timeStamp | date:'yyyy-MM-dd, HH:mm' }}">
    </mat-form-field>

    <!--  IF Correct -->
    @if (data.user) {
      <mat-form-field>
        <mat-label>Personnummer:</mat-label>
        <input matInput readonly
               value="{{ data.user.personalNumber | slice:0:8 }}-{{ data.user.personalNumber | slice:8 }}">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Namn</mat-label>
        <input matInput readonly value="{{data.user.name}}">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Ålder</mat-label>
        <input matInput readonly value="{{data.user.age}}">
      </mat-form-field>
    }
    <!--  IF Error-->
    @if (data.errorCode) {
      <mat-form-field>
        <mat-label>Felmeddelande</mat-label>
        <input class="line-height" matInput readonly value="{{data.errorCode}}">
      </mat-form-field>
    }

    @if (data.details) {
      <mat-form-field>
        <mat-label>Detaljer</mat-label>
        <textarea matInput readonly rows="2"
                  value="{{data.details}}"></textarea>
      </mat-form-field>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close="true" mat-flat-button>Stäng</button>
</mat-dialog-actions>

